import { Link } from 'react-router-dom';

export function Docs() {
  return (
    <div className="page">
      <header className="page__header">
        <p className="eyebrow">Docs</p>
        <h1>Start simple. Open the deeper references when you need them.</h1>
        <p className="lede">
          The Easy Start guide is the shortest route to a working browser setup. The user guide,
          tools reference, and SDK docs remain available for more detailed work.
        </p>
      </header>

      <section className="install-card install-card--accent">
        <h2>Easy Start</h2>
        <p>New project, existing repo, multi-repo system, Codex CLI, Anthropic API, browser routes, and troubleshooting.</p>
        <div className="hero__cta">
          <Link to="/guide/easy-start" className="btn btn--primary">Read online</Link>
          <a href="/docs/easy-start.md" className="btn btn--ghost">Markdown</a>
          <a href="/docs/easy-start.html" className="btn btn--ghost">HTML</a>
          <a href="/docs/easy-start.pdf" className="btn btn--ghost">PDF</a>
        </div>
      </section>

      <section className="install-card">
        <h2>Computer Use browser setup</h2>
        <p>Install the extension, connect its native host, choose Architect permissions and troubleshoot native dialogs.</p>
        <Link to="/guide/computer-use" className="btn btn--ghost">Connect your browser</Link>
      </section>

      <section className="install-card">
        <h2>User guide</h2>
        <p>The maintained walkthrough for installation, instances, providers, Architect, Explorer, VS Code, multi-repo setups, and troubleshooting.</p>
        <Link to="/guide/overview" className="btn btn--ghost">Open the user guide</Link>
      </section>

      <section className="install-card">
        <h2>Reference docs</h2>
        <div className="hero__cta">
          <Link to="/tools" className="btn btn--ghost">Tools reference</Link>
          <Link to="/sdk" className="btn btn--ghost">Plugin SDK</Link>
          <a href="https://github.com/mmethodz/dreamgraph/tree/main/docs" className="btn btn--ghost" target="_blank" rel="noreferrer">Repository docs</a>
        </div>
      </section>
    </div>
  );
}
